import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as timeUtil from '@chronos/time-util';
import EditIcon from '../Icons/EditIcon';
import UserAvatar from '../UserAvatar';
import Tooltip from '../Tooltip';

import * as S from './styled';

const Estimate = ({
  isMobile,
  isLoading,
  showEditBtn,
  estimates,
  onUserClick,
  totalEstimateString,
  hasOffset,
  onEstimateEdit,
  userStatsMap,
  selectedUserIds,
}) => {
  const [showButton, setShowButton] = useState(isMobile);
  const isEstimated = estimates.length > 0;
  const iconSize = isMobile ? ['22px', '22px'] : 'middle';
  const emptyEstimateText = isLoading ? '' : 'not estimated';

  return (
    <S.Estimate
      hasOffset={hasOffset}
      onMouseEnter={() => {
        if (!isMobile) setShowButton(true);
      }}
      onMouseLeave={() => {
        if (!isMobile) setShowButton(false);
      }}
    >
      <S.TotalEstimate>
        {isEstimated ? (
          <S.Header>Estimate time</S.Header>
        ) : (
          <S.LightText>{emptyEstimateText}</S.LightText>
        )}
        <S.Text>{totalEstimateString}</S.Text>
        <S.AvatarsGroup>
          {estimates.map((estimate) => (
            <S.GroupedAvatar
              key={estimate.id}
              onClick={() => {
                onUserClick(estimate.accountId);
              }}
            >
              <Tooltip
                title={
                  <S.Tooltip>
                    <S.Column>
                      <S.TooltipText>{estimate.user?.fullName}:</S.TooltipText>
                    </S.Column>
                    <S.MarginLeft />
                    <S.Column>
                      <S.TooltipText>
                        {timeUtil.stj(estimate.seconds)} estimate
                      </S.TooltipText>
                      {userStatsMap[estimate.accountId]?.loggedSeconds > 0 && (
                        <S.TooltipText>
                          {userStatsMap[estimate.accountId].loggedString} logged
                        </S.TooltipText>
                      )}
                    </S.Column>
                  </S.Tooltip>
                }
              >
                <UserAvatar
                  src={
                    estimate.user?.avatarUrl
                      ? `${estimate.user.avatarUrl}/50.png`
                      : null
                  }
                  initials={estimate.user?.initials}
                  isSelected={
                    selectedUserIds.includes(estimate.user?.id) ??
                    estimate.isSelected ??
                    false
                  }
                  size="tiny"
                />
              </Tooltip>
            </S.GroupedAvatar>
          ))}
        </S.AvatarsGroup>
        {showEditBtn && showButton && (
          <S.EditEstimateButton
            appearance="subtle-link"
            onClick={onEstimateEdit}
            spacing="none"
          >
            <EditIcon size={iconSize} />
          </S.EditEstimateButton>
        )}
      </S.TotalEstimate>
    </S.Estimate>
  );
};

Estimate.propTypes = {
  isMobile: PropTypes.bool,
  isLoading: PropTypes.bool,
  hasOffset: PropTypes.bool,
  showEditBtn: PropTypes.bool,
  onEstimateEdit: PropTypes.func,
  estimates: PropTypes.array,
  onUserClick: PropTypes.func,
  totalEstimateString: PropTypes.string,
  selectedUserIds: PropTypes.array,
  userStatsMap: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string,
      estimatedSeconds: PropTypes.number,
      estimatedString: PropTypes.string,
      loggedString: PropTypes.string,
      user: PropTypes.object,
      loggedSeconds: PropTypes.number,
    })
  ),
};

Estimate.defaultProps = {
  isMobile: false,
  isLoading: true,
  hasOffset: false,
  showEditBtn: true,
  estimates: [],
  totalEstimateString: '',
  onEstimateEdit: () => {},
  onUserClick: () => {},
  selectedUserIds: [],
};

export default Estimate;
